import {
	useMutation,
	UseMutationResult,
	useQueryClient,
} from '@tanstack/react-query'

import { UpdateLocationZoneVolumeRequestDTO } from '@core/api/dtos/request/location/updateZoneVolume'
import { locationService } from '@core/api/services/locationService'

import { DEFAULT_PARAMS } from './common'

export const usePatchLocationZoneVolume = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseMutationResult<
	void,
	Error,
	{
		locationUUID: string
		zoneId: number
		data: UpdateLocationZoneVolumeRequestDTO
	},
	any
> => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ locationUUID, zoneId, data }) =>
			locationService
				.patchLocationZoneVolume(locationUUID, zoneId, data, config)
				.then(() => {}),
		onSuccess: async (_data, vars, ctx) => {
			// refresh location monitor page data
			await queryClient.invalidateQueries({
				queryKey: ['location', 'uuid', vars.locationUUID],
			})
			options?.onSuccess?.(_data, vars, ctx)
		},
		onError: (err: any, vars: any, ctx: any) => {
			options?.onError?.(err, vars, ctx)
		},
	}) as any
}
